export default __webpack_public_path__ + "static/media/Darkblade's Leggings of Consumed Souls.249293ce.jpg";